export default {
    computed: {
        currentLang() {
            return this.$store.state.languages.current;
        },
        list() {
            return [
                {
                    text:this.$t('header.services.title'),
                    url: '/attestation-certificat',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                },
                {
                    text: this.$t('header.repair'),
                    url: '/store',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                },
                {
                    text: this.$t('header.spareparts'),
                    url: '/partners',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                    
                },
                
                
                {
                    text: this.$t('header.manuals'),
                    url: '/manuals',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                    
                },

                {
                    text: this.$t('header.advice'),
                    url: '/videos',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                    
                },
               
                {
                    text: this.$t('header.news.title'),
                    url: '/activity',
                    target: '_self',
                    newsMega: false,
                    openMega: true,
                    isLink: false,
                    isService: true,
                    isNews: false
                },

                {
                    text: this.$t('header.news.clubs'),
                    url: '/clubs-collectionneurs-voitures',
                    target: '_self',
                    newsMega: false,
                    openMega: false,
                    isLink: true,
                    isService: false,
                    isNews: false
                },

            ]
        },
        services() {
            return [
                {
                    'text': this.$t('header.discover'),
                    list: [
        
                        {
                            text: this.$t('header.services.retrofit'),
                            url: '/kit-retrofit-homologue',
                            target: '_self'
                        },
                        {
                            text: this.$t('header.services.historical'),
                            url: '/fonds-historique',
                            target: '_self'
                        },
                        {
                            text: this.$t('header.services.clubs'),
                            url: '/clubs-collectionneurs-voitures',
                            target: '_self'
                        },
                        
                    ]
                },
                {
                    'text': this.$t('header.news.title'),
                    list: [
                        {
                            text: this.$t('header.calendar.title'),
                            url: '/calendrier',
                            target: '_self'
                        },
                        {
                            text: this.$t('header.news.events'),
                            url: '/evenement',
                            target: '_self'
                        },
                        {
                            text: this.$t('header.news.magazines'),
                            url: '/magazines',
                            target: '_self'
                        },
                        {
                            text: this.$t('header.news.collections'),
                            url: '/collections',
                            target: '_self'
                        },
                        {
                            text: "newsletter",
                            url: '/newsletter',
                            target: '_self'
                        },
                    ]
                },
            ]
        },
        
        originals() {
            return [
                {
                    url: 'https://theoriginals-store.renault.com/',
                    text: this.$t('header.store')
                },
                {
                    url: 'https://theoriginals.renault.com/',
                    text: this.$t("header.tooltip.museum")
                },
                {
                    url: 'https://theoriginals.renault.com/go/site-pays',
                    text: this.$t("header.tooltip.country")
                }
            ]
        }
    },
}


